var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadDeskApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_763_3680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3055 0.500732C6.45263 0.500732 0.845703 6.10765 0.845703 12.9606C0.845703 19.8135 6.45263 25.4204 13.3055 25.4204C20.1584 25.4204 25.7654 19.8135 25.7654 12.9606C25.7654 6.10765 20.1584 0.500732 13.3055 0.500732ZM13.3055 22.9284C7.82321 22.9284 3.33767 18.4429 3.33767 12.9606C3.33767 7.47824 7.82321 2.9927 13.3055 2.9927C18.7879 2.9927 23.2734 7.47824 23.2734 12.9606C23.2734 18.4429 18.7879 22.9284 13.3055 22.9284Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4335 15.0787C12.9318 15.577 13.6794 15.577 14.1778 15.0787L17.1681 12.0884C17.6664 11.59 17.6664 10.8424 17.1681 10.344C16.6698 9.84569 15.9221 9.84569 15.4238 10.344L14.5517 11.2161V6.7306C14.5517 5.98297 14.0533 5.48462 13.3057 5.48462C12.5581 5.48462 12.0597 5.98297 12.0597 6.7306V11.2161L11.1874 10.3439C10.6891 9.84551 9.94145 9.84551 9.4431 10.3439C8.94475 10.8422 8.94475 11.5898 9.4431 12.0882L12.4335 15.0787Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2895 16.6985H8.32167C7.57403 16.6985 7.07568 17.1968 7.07568 17.9445C7.07568 18.6921 7.57403 19.1905 8.32167 19.1905H18.2895C19.0372 19.1905 19.5355 18.6921 19.5355 17.9445C19.5355 17.1968 19.0372 16.6985 18.2895 16.6985Z",
    fill: "#C8C8C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_763_3680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 25.6316,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDeskApp);
export default __webpack_public_path__ + "static/media/downloadDeskApp.588348f70e8c48bd8bc010ccb7b6bf3b.svg";
export { ForwardRef as ReactComponent };